import React, { useEffect, useState } from "react";
import { useGetAdminQuery, useUpdateProfileMutation, useUpdatePasswordMutation } from "../../redux/api";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import validator from "validator";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useHistory } from "react-router";
import { ENV } from "config/config";
import FullPageLoader from "components/FullPageLoader/FullPageLoader";

function Profile() {
  const [admin, setAdmin] = useState(null);

  const [password, setPassword] = useState({
    currentPassword: "",
    password: "",
    confirm: "",
  });

  const [showPasswords, setShowPasswords] = useState({
    password: false,
    verifyPassword: false,
    currentPassword: false,
  });

  const [pic, setPic] = useState({
    photo: null,
  });

  const history = useHistory();
  const [nameMsg, setNameMsg] = useState("");
  const [emailMsg, setEmailMsg] = useState("");
  const [phoneMsg, setPhoneMsg] = useState("");
  const [passwordMsgCheck, setPasswordMsgCheck] = useState(false);
  const [passwordMsg, setPasswordMsg] = useState("");
  const [adminRole, setAdminRole] = useState("");
  const adminId = localStorage.getItem("userID");

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const { data: adminData, isLoading: isAdminLoading } = useGetAdminQuery(adminId, { skip: !adminId });
  const [updateProfileMut, { isLoading: isUpdatingProfile }] = useUpdateProfileMutation();
  const [updatePasswordMut, { isLoading: isUpdatingPassword }] = useUpdatePasswordMutation();
  const isGlobalLoading = isAdminLoading || isUpdatingProfile || isUpdatingPassword;


  useEffect(() => {
    if (adminData) {
      const staff = adminData?.staff || adminData;
      setAdmin(staff);
    }
  }, [adminData]);

  useEffect(() => {
    if (admin && admin.Role) {
      setAdminRole(admin.Role);
    }
  }, [admin]);

  useEffect(() => {
    if (password.confirm && password.password) {
      if (password.password === password.confirm) {
        setPasswordMsgCheck(false);
      } else {
        setPasswordMsg("New password and confirm password are not same.");
        setPasswordMsgCheck(true);
      }
    } else {
      setPasswordMsgCheck(false);
    }
  }, [password]);

  const submitCallBack = (e) => {
    e.preventDefault();

    let firstName = "";

    if (!admin.firstName) firstName = "This field is required.";
    else {
      let regex = /^[a-zA-Z ]{3,30}$/;
      if (!admin.firstName.match(regex))
        firstName =
          "Name should be atleast 3 characters long and should only contain alphabets";
    }

    setNameMsg(firstName);

    if (firstName) return;

    let formData = new FormData();
    // for (const key in admin)
    //   formData.append(key, admin[key])
    formData.append("firstName", admin.firstName);
    formData.append("lastName", admin.lastName);
    
    setNameMsg("");
    setPhoneMsg("");
    updateProfileMut(formData);
  };

  const passwordForm = (e) => {
    e.preventDefault();

    if (
      !validator.isEmpty(password.currentPassword) &&
      !validator.isEmpty(password.password) &&
      !validator.isEmpty(password.confirm)
    ) {
      if (password.password === password.confirm) {
        if (validator.isStrongPassword(password.password)) {
          setPasswordMsgCheck(false);
          let formData = new FormData();
          formData.append("password", password.password);
          formData.append("currentPassword", password.currentPassword);
          updatePasswordMut(formData);

          setPassword({
            currentPassword: "",
            password: "",
            confirm: "",
          });
          e.target[0].value = "";
          e.target[1].value = "";
          e.target[2].value = "";
        } else {
          setPasswordMsg(
            "Password must contain Upper Case, Lower Case, a Special Character, a Number and must be at least 8 characters in length"
          );
          setPasswordMsgCheck(true);
        }
      } else {
        setPasswordMsg("New password & confirm password are not same.");
        setPasswordMsgCheck(true);
      }
    } else {
      setPasswordMsg("You have to fill all fields to change password.");
      setPasswordMsgCheck(true);
    }
  };

  const onFileChange = (e) => {
    let file = e.target.files[0];
    if (file) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        setAdmin({ ...admin, photo: reader.result });
      };
      setPic({ photo: file });
      // setPic({ ...pic, image: file })
    }
  };

  const submitPic = (e) => {
    e.preventDefault();
    if (pic.photo) {
      let formData = new FormData();
      for (const key in pic) formData.append(key, pic[key]);

      updateProfileMut(formData);
      document.querySelector("#imageUploader").value = null;
      setPic({ ...pic, photo: null });
    } else {
      toast.error("Please upload pic before updating.");
    }
  };

  return (
    <>
      {isGlobalLoading ? (
        <FullPageLoader />
      ) : (
        <Container fluid>
          <div className="section-image" data-image="../../assets/img/bg5.jpg">
            {/* you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " */}
            <Container>
              <Row>
                <Col xl="8">
                  <Form
                    action=""
                    className="form"
                    onSubmit={(e) => submitCallBack(e)}
                  >
                    <Card className="pb-4 table-big-boy">
                      <Card.Header>
                        <Card.Header className="pl-0">
                          <Card.Title as="h4">Profile</Card.Title>
                        </Card.Header>
                      </Card.Header>
                      <Card.Body>
                        <Row>
                          <Col md="6">
                            <Form.Group>
                              <label>
                                First Name
                                <span> *</span>
                              </label>
                              <Form.Control
                                value={admin?.firstName}
                                onChange={(e) =>
                                  setAdmin({
                                    ...admin,
                                    firstName: e.target.value,
                                  })
                                }
                                placeholder="Name"
                                type="text"
                              ></Form.Control>
                              <span className={nameMsg ? `` : `d-none`}>
                                <label className="pl-1">{nameMsg}</label>
                              </span>
                            </Form.Group>
                          </Col>
                          <Col md="6">
                            <Form.Group>
                              <label>Last Name</label>
                              <Form.Control
                                value={admin?.lastName}
                                onChange={(e) =>
                                  setAdmin({
                                    ...admin,
                                    lastName: e.target.value,
                                  })
                                }
                                placeholder="Last Name"
                                type="text"
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row>
                          <Col className="pl-3" md="6">
                            <Form.Group>
                              <label>
                                Email<span> *</span>
                              </label>
                              <Form.Control
                                className="input-bg"
                                value={admin?.email}
                                placeholder="Email"
                                type="email"
                                disabled={true}
                              ></Form.Control>
                              <span className={emailMsg ? `` : `d-none`}>
                                <label className="pl-1">Email Required</label>
                              </span>
                            </Form.Group>
                          </Col>
                          <Col md="6">
                            <Form.Group>
                              <label>Role</label>
                              <Form.Control
                                className="input-bg"
                                readOnly
                                value={adminRole?.title}
                                type="text"
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <div className="d-flex justify-content-end align-items-center">
                              <Button
                                className="btn-filled"
                                type="button"
                                onClick={submitCallBack}
                              >
                                Update Profile
                              </Button>
                            </div>
                          </Col>
                        </Row>
                        <div className="clearfix"></div>
                      </Card.Body>
                    </Card>
                  </Form>
                </Col>
                <Col xl="4">
                  <Card className="card-user table-big-boy">
                    <Card.Body>
                      <div className="author">
                        <img
                          alt="Profile Pic"
                          className="avatar border-gray"
                          src={
                            pic.photo
                              ? admin.photo
                              : ENV.assetsUrl + "users/" + admin?.photo
                          }
                        />
                        <Card.Title as="h5">
                          {admin?.firstName + " " + admin?.lastName}
                        </Card.Title>
                        <p className="card-description"></p>
                      </div>

                      <Form className="profile-main-form">
                        <Form.Group className="pl-3 pr-3">
                          <div className="input-file-btn-holder ">
                            <Form.Control
                              className=""
                              placeholder="Company"
                              type="file"
                              varient="info"
                              accept=".png,.jpeg,.jpg"
                              onChange={(e) => onFileChange(e)}
                              id="imageUploader"
                            ></Form.Control>
                            <span className="input-file-btn">Choose Image</span>
                          </div>

                          <div className="text-center">
                            <Button
                              className="btn-filled mt-5"
                              type="button"
                              onClick={submitPic}
                            >
                              Update Pic
                            </Button>
                          </div>
                        </Form.Group>
                      </Form>
                    </Card.Body>
                    <Card.Footer>
                      <div className="pb-2"></div>
                    </Card.Footer>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col sm="12">
                  <Form
                    action=""
                    className="form"
                    onSubmit={(e) => passwordForm(e)}
                  >
                    <Card className="table-big-boy pb-4">
                      <Card.Header>
                        <Card.Header className="pl-0">
                          <Card.Title as="h4">Change Password</Card.Title>
                        </Card.Header>
                      </Card.Header>
                      <Card.Body>
                        <Row>
                          <Col md="4">
                            <Form.Group>
                              <label>
                                Current Password
                                <span> *</span>
                                {password.currentPassword ? (
                                  showPasswords.currentPassword ? (
                                    <FaEye
                                      onClick={() =>
                                        setShowPasswords({
                                          ...showPasswords,
                                          currentPassword: false,
                                        })
                                      }
                                    />
                                  ) : (
                                    <FaEyeSlash
                                      onClick={() =>
                                        setShowPasswords({
                                          ...showPasswords,
                                          currentPassword: true,
                                        })
                                      }
                                    />
                                  )
                                ) : (
                                  ""
                                )}
                              </label>
                              <Form.Control
                                placeholder="Current Password"
                                type={
                                  showPasswords.currentPassword
                                    ? "text"
                                    : "password"
                                }
                                onChange={(e) => {
                                  setPassword({
                                    ...password,
                                    currentPassword: e.target.value,
                                  });
                                }}
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col md="4">
                            <Form.Group>
                              <label>
                                New Password
                                <span> *</span>
                                {password.password ? (
                                  showPasswords.password ? (
                                    <FaEye
                                      onClick={() =>
                                        setShowPasswords({
                                          ...showPasswords,
                                          password: false,
                                        })
                                      }
                                    />
                                  ) : (
                                    <FaEyeSlash
                                      onClick={() =>
                                        setShowPasswords({
                                          ...showPasswords,
                                          password: true,
                                        })
                                      }
                                    />
                                  )
                                ) : (
                                  ""
                                )}
                              </label>
                              <Form.Control
                                placeholder="New Password"
                                type={
                                  showPasswords.password ? "text" : "password"
                                }
                                onChange={(e) => {
                                  setPassword({
                                    ...password,
                                    password: e.target.value,
                                  });
                                }}
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col md="4">
                            <Form.Group>
                              <label>
                                Confirm Password
                                <span> *</span>
                                {password.confirm ? (
                                  showPasswords.verifyPassword ? (
                                    <FaEye
                                      onClick={() =>
                                        setShowPasswords({
                                          ...password,
                                          verifyPassword: false,
                                        })
                                      }
                                    />
                                  ) : (
                                    <FaEyeSlash
                                      onClick={() =>
                                        setShowPasswords({
                                          ...password,
                                          verifyPassword: true,
                                        })
                                      }
                                    />
                                  )
                                ) : (
                                  ""
                                )}
                              </label>
                              <Form.Control
                                placeholder="Confirm Password"
                                type={
                                  showPasswords.verifyPassword
                                    ? "text"
                                    : "password"
                                }
                                onChange={(e) =>
                                  setPassword({
                                    ...password,
                                    confirm: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row>
                          <Form.Group
                            className={passwordMsgCheck ? `` : `d-none`}
                          >
                            <label className="pl-3">{passwordMsg}</label>
                          </Form.Group>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <div className="d-flex justify-content-end align-items-center">
                              <Button className="btn-filled" type="submit">
                                Update Password
                              </Button>
                            </div>
                          </Col>
                        </Row>
                        <div className="clearfix"></div>
                      </Card.Body>
                    </Card>
                  </Form>
                </Col>
              </Row>
            </Container>
          </div>
        </Container>
      )}
    </>
  );
}

export default Profile;
